import Banner from "~/ui-rtk/components/ui/common/Banner"
import { brandRoutes } from "~/ui-rtk/constants/routes"
import { CompanyTier } from "~/ui-rtk/api/types"
import useAccess from "~/ui-rtk/hooks/access"
import useCurrentCompany from "~/ui-rtk/hooks/current-company"

/**
 * Super-admin-only notice that the current company is on the free Share of
 * Search tier. An SOS_FREE company has no Fivetran group and no Airbyte
 * workspace, so every connector attempt stalls on "Preparing the
 * connectors..." with nothing on screen saying why. Regular users never see
 * this: SubscriptionGuard already scopes them to the SoS surface, and only a
 * super admin can run the upgrade (Settings > Company > Company Tier).
 */
export default function SosTierAdminAlert() {
  const { isSuperAdmin } = useAccess()
  const currentCompany = useCurrentCompany()

  if (!isSuperAdmin || currentCompany?.tier !== CompanyTier.SOS_FREE) {
    return null
  }

  return (
    <Banner
      title={`${currentCompany.name} is a Share of Search (SOS_FREE) company`}
      variant="warning"
      link={{
        to: brandRoutes.SETTINGS.COMPANY,
        label: "Open Company Settings to upgrade",
      }}
    >
      This company signed up through the free Share of Search flow, so it has no
      Fivetran or Airbyte destination yet. Connectors will not connect until it
      is upgraded to STANDARD.
    </Banner>
  )
}
